/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  { Node }   // The form element in question <form></form>
 * @return { String } The serialized form data
 */
const serialize = function (form) {
  // Setup our serialized data
  const serialized = []

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i += 1) {
    const field = form.elements[i]

    // Don't serialize fields without a name, submits, buttons,
    // file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button"
    )
      continue

    // If a multi-select, get all selections
    if (field.type === "select-multiple") {
      for (let n = 0; n < field.options.length; n += 1) {
        if (field.options[n].selected)
          serialized.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[n].value)}`
          )
      }
    } else if ((field.type !== "checkbox" && field.type !== "radio") || field.checked) {
      // Convert field data to a query string
      serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`)
    }
  }

  return serialized.join("&")
}
/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
// var debounce = (fn) => {

// 	// Setup a timer
// 	var timeout

// 	// Return a function to run debounced
// 	return function () {

// 		// Setup the arguments
// 		var context = this
// 		var args = arguments

// 		// If there's a timer, cancel it
// 		if (timeout) {
// 			window.cancelAnimationFrame(timeout)
// 		}

// 		// Setup the new requestAnimationFrame()
// 		timeout = window.requestAnimationFrame(function () {
// 			fn.apply(context, args)
// 		})
// 	}
// }

// function debounce(func, wait = 100) {
//   let timeout
//   return (...args) => {
//     const context = this
//     clearTimeout(timeout)
//     timeout = setTimeout(() => callback.apply(context, args), wait)
//   }
// }

/* Post form data
 *  Replaces jQuery $.post with vanilla javascript, the XMLHttpRequest object.
 *  @params { Node } // The form element in question <form></form>
 *  @params { Function }   // A callback function to run after the request is succesfully called [cb]
 *  @params { e }    // The event, used in preventDefault()
 */
const postFormData = (form, cb, loader, e) => {
  e.preventDefault()

  const xhr = new XMLHttpRequest()
  xhr.open("POST", "", true)
  if (loader) document.body.classList.add("loading")
  xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
  xhr.onload = function sendResponse() {
    const data = xhr.responseText
    cb(data)
  }
  xhr.send(serialize(form))
}

const decodeEntities = (function () {
  // this prevents any overhead from creating the object each time
  const element = document.createElement("div")

  function decodeHTMLEntities(str) {
    if (str && typeof str === "string") {
      // strip script/html tags
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "")
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "")
      element.innerHTML = str
      str = element.textContent
      element.textContent = ""
    }

    return str
  }

  return decodeHTMLEntities
})()

/* getCookie function for django csrf token
 *  ... write docs ...
 *  @params { name } // The form element in question <form></form>
 *  example use: const csrftoken = getCookie('csrftoken')
 */

const getCookie = (name) => {
  let cookieValue = null
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";")
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === `${name}=`) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
        break
      }
    }
  }
  return cookieValue
}

// const getCookie = (name) => {
//     const cookies = document.cookie.split('; ').map(cookie => cookie.split('='))
//     const cookie = cookies.find(([key]) => key === name)
//     return cookie ? decodeURIComponent(cookie[1]) : null
// }

/* Calculate aspect ratio */
const calculateAspectRatio = (srcWidth, srcHeight, maxWidth, maxHeight) => {
  const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)
  return { width: srcWidth * ratio, height: srcHeight * ratio }
}

function articleImagesFormat() {
  const articleBody = document.querySelector(".article-body")
  if (articleBody) {
    const articleImg = articleBody.querySelectorAll("img")
    articleImg.forEach((img) => {
      if (window.innerWidth > 414) {
        if (img.getBoundingClientRect().width > img.getBoundingClientRect().height) {
          img.style.width = "100%"
        } else {
          img.style.maxWidth = "645px"
        }
      } else {
        img.style.width = "100%"
      }
    })
  }
}

// (function mainMinHeight() {
//     const header = document.querySelector('header')
//     const main = document.querySelector('#main-content')
//     const footer = document.querySelector('footer')

//     let headerHeight = header.clientHeight
//     let footerHeight = footer.clientHeight

//     main.style.minHeight = `calc(100vh - ${headerHeight + footerHeight + 96}px)`;

// })()

function runOnLoadAndResize() {
  articleImagesFormat()
  window.addEventListener("resize", articleImagesFormat)
}

runOnLoadAndResize()

/* Accordion */
const accordion = () => {
  const triggers = document.querySelectorAll(".collapse__title")

  const toggleElement = (e) => {
    const content = e.target.closest(".accordion").querySelector(".collapse__content")
    const menuLink = e.target.closest(".accordion").querySelector(".js-menu-link")
    const expandIcon = e.target.querySelector(".icon-expand")
    const collapseIcon = e.target.querySelector(".icon-collapse")
    e.target.classList.toggle("active")
    e.target.toggleAttribute("data-expanded")
    content.classList.toggle("active")
    // Don't toggle text-white for mobile menu accordions (they have bg-neutral-50)
    if (!content.classList.contains("drop-menu")) {
      menuLink.classList.toggle("text-white")
    }

    if (content.classList.contains("active")) {
      content.style.maxHeight = `${content.scrollHeight + 50}px`
      expandIcon.classList.add("hidden")
      collapseIcon.classList.remove("hidden")
    } else {
      content.removeAttribute("style")
      expandIcon.classList.remove("hidden")
      collapseIcon.classList.add("hidden")
    }

    if (content.classList.contains("menu-third-level__list")) {
      document.documentElement.classList.remove("accordion-expanded")
      document.documentElement.classList.add("accordion-expanded")
    }
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", toggleElement)
  })
}

/* Auto-open first accordion in mobile submenu */
const autoOpenFirstAccordion = () => {
  if (window.innerWidth >= 1024) return // Desktop only

  const mainCategoryLinks = document.querySelectorAll("[data-submenu]")

  mainCategoryLinks.forEach((link) => {
    link.addEventListener("click", function () {
      const submenuId = this.getAttribute("data-submenu")

      // Wait for hyperscript to show the submenu
      setTimeout(() => {
        const submenu = document.getElementById(submenuId)
        if (!submenu) return

        const firstAccordion = submenu.querySelector(".accordion")
        if (!firstAccordion) return

        const collapseTitle = firstAccordion.querySelector(".collapse__title")
        if (!collapseTitle) return

        // Only click if not already expanded
        if (!collapseTitle.hasAttribute("data-expanded")) {
          collapseTitle.click()
        }
      }, 150)
    })
  })
}

const accordionMobile = (element) => {
  if (window.innerWidth < breakpoints.phabletMax) {
    const triggers = element

    const toggleElement = (e) => {
      const content = e.target.nextElementSibling
      const parent = e.target.closest(".product-filters__form__block")
      parent.classList.toggle("active")
      e.target.classList.toggle("active")
      content.classList.toggle("active")

      if (content.classList.contains("active")) {
        content.style.maxHeight = `${content.scrollHeight + 50}px`
      } else {
        content.removeAttribute("style")
      }
    }

    if (triggers && triggers.length > 0) {
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", toggleElement)
      })
    }
  }
}

const accordionWithCaret = () => {
  document.addEventListener("click", (event) => {
    const toggle = event.target.closest(".accordion-toggle")
    if (toggle) {
      const accordion = toggle.closest(".accordion")
      const content = accordion.querySelector(".accordion-content")
      const iconCaret = accordion.querySelector(".accordion-icon svg path")
      const iconArrow = accordion.querySelector(".icon-arrow")

      if (content) {
        const isExpanded = content.style.maxHeight && content.style.maxHeight !== "0px"
        content.style.maxHeight = isExpanded ? "0px" : `${content.scrollHeight}px`

        if (toggle.hasAttribute("data-state")) {
          toggle.setAttribute("data-state", isExpanded ? "closed" : "open")

          // Toggle Tailwind text color
          toggle.classList.toggle("text-neutral-200", isExpanded) // Default color
          toggle.classList.toggle("text-white", !isExpanded) // Color when open
        }

        if (iconCaret) {
          iconCaret.setAttribute(
            "d",
            isExpanded
              ? "M7.625 0.125V6.375H13.875V7.625H7.625V13.875H6.375V7.625H0.125V6.375H6.375V0.125H7.625Z" // Plus
              : "M0 6.375H14V7.625H0V6.375Z" // Minus
          )
        } else if (iconArrow) {
          // Replace the SVG content instead of rotating
          const plusSVG = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="18" height="18" rx="9" stroke="black"/>
            <path d="M9.5 4.8125V14.1875M14.1875 9.5L4.8125 9.5" stroke="black" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>`
          const minusSVG = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="18" height="18" rx="9" stroke="black"/>
            <path d="M14.1875 9.5L4.8125 9.5" stroke="black" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>`

          iconArrow.innerHTML = isExpanded ? plusSVG : minusSVG
        }
      }
    }
  })

  const productPage = document.getElementById("catalogue-detail")

  // IN CASE WE NEED THE FIRST ACCORDION OPENED BY DEFAULT

  // if (productPage) {
  //     const productPageFirstAccordion = productPage.querySelector(".accordion")
  //     // Ensure the first accordion is open on page load

  //     if (productPageFirstAccordion) {
  //         const firstContent = productPageFirstAccordion.querySelector(".accordion-content")
  //         const firstIconCaret = productPageFirstAccordion.querySelector(".accordion-icon svg path")
  //         const firstIconArrow = productPageFirstAccordion.querySelector(".icon-arrow")

  //         if (firstContent) {
  //             firstContent.style.maxHeight = `${firstContent.scrollHeight}px`

  //             if (firstIconCaret) {
  //                 firstIconCaret.setAttribute(
  //                     "d",
  //                     "M0 6.375H14V7.625H0V6.375Z" // Minus
  //                 )
  //             } else if (firstIconArrow) {
  //                 firstIconArrow.style.transform = "rotate(180deg)"
  //                 firstIconArrow.style.transition = "transform 0.3s ease"
  //             }
  //         }
  //     }
  // }
}

const adjustCustomerPagesAccordion = () => {
  // Special Case: remove collapse functionality in customer account pages desktop
  // const collapseTitle = document.querySelectorAll('.account__sidebar h2')
  // const collapseContent = document.querySelectorAll('.account__sidebar ul')
  // if (collapseTitle) {
  //   collapseTitle.forEach((el) => {
  //     if (window.innerWidth > 851) {
  //       el.classList.remove('collapse__title')
  //       el.classList.remove('collapse__title--arrow')
  //       el.classList.remove('collapse--mobile')
  //     } else {
  //       el.classList.add('collapse__title')
  //       el.classList.add('collapse__title--arrow')
  //       el.classList.add('collapse--mobile')
  //     }
  //   })
  //   collapseContent.forEach((el) => {
  //     if (window.innerWidth > 852) {
  //       el.classList.remove('collapse__content')
  //     } else {
  //       el.classList.add('collapse__content')
  //     }
  //   })
  // }
}

// window.addEventListener('load', adjustCustomerPagesAccordion)
// window.addEventListener('resize', adjustCustomerPagesAccordion)

/*! Done Typing
 * Run callback x seconds after typing
 * (c) 2020 Michelle Kondou, MIT License
 * @params { Node } // element
 * @params { Function } // callback
 * example use: doneTyping(element, functionName) no parenthesis
 */
const doneTyping = (element, callback, wait = 6000) => {
  // console.log({ wait, element, callback })
  let time = null
  let TM
  const excludedKeys = ["Alt", "Tab", "Control"]

  const runCallback = (e) => {
    // if(!excludedKeys.includes(e.key)) {
    time = new Date().getTime()
    if (TM) clearTimeout(TM)
    TM = setTimeout(async () => {
      const currentTime = new Date().getTime()
      const timeDiff = currentTime - time
      if (timeDiff >= wait) await callback
    }, wait)
    element.removeEventListener("keyup", runCallback)
    element.removeEventListener("input", runCallback)
    // }
  }

  element.addEventListener("input", runCallback)
}

const removeAccents = (text) =>
  typeof text !== "string"
    ? text
    : // global replace of uppercase accented characters
      text
        .replace(/\u0386/g, "\u0391") // 'Ά':'Α'
        .replace(/\u0388/g, "\u0395") // 'Έ':'Ε'
        .replace(/\u0389/g, "\u0397") // 'Ή':'Η'
        .replace(/\u038A/g, "\u0399") // 'Ί':'Ι'
        .replace(/\u038C/g, "\u039F") // 'Ό':'Ο'
        .replace(/\u038E/g, "\u03A5") // 'Ύ':'Υ'
        .replace(/\u038F/g, "\u03A9") // 'Ώ':'Ω'
        .replace(/\u0390/g, "\u03B9") // 'ΐ':'ι'
        // replace( /\u03AA/g, "\u0399" ). // 'Ϊ':'Ι'
        // replace( /\u03AB/g, "\u03A5" ). // 'Ϋ':'Υ'
        .replace(/\u03AC/g, "\u03B1") // 'ά':'α'
        .replace(/\u03AD/g, "\u03B5") // 'έ':'ε'
        .replace(/\u03AE/g, "\u03B7") // 'ή':'η'
        .replace(/\u03AF/g, "\u03B9") // 'ί':'ι'
        .replace(/\u03B0/g, "\u03C5") // 'ΰ':'υ'
        .replace(/\u03CA/g, "\u03B9") // 'ϊ':'ι'
        .replace(/\u03CB/g, "\u03C5") // 'ϋ':'υ'
        .replace(/\u03CC/g, "\u03BF") // 'ό':'ο'
        .replace(/\u03CD/g, "\u03C5") // 'ύ':'υ'
        .replace(/\u03CE/g, "\u03C9") // 'ώ':'ω';

const removeAccentsTest = (text) => {
  if (typeof text === "string") {
    text
      .replace(/\u0386/g, "\u0391") // 'Ά':'Α'
      .replace(/\u0388/g, "\u0395") // 'Έ':'Ε'
      .replace(/\u0389/g, "\u0397") // 'Ή':'Η'
      .replace(/\u038A/g, "\u0399") // 'Ί':'Ι'
      .replace(/\u038C/g, "\u039F") // 'Ό':'Ο'
      .replace(/\u038E/g, "\u03A5") // 'Ύ':'Υ'
      .replace(/\u038F/g, "\u03A9") // 'Ώ':'Ω'
      .replace(/\u0390/g, "\u03B9") // 'ΐ':'ι'
      // replace( /\u03AA/g, "\u0399" ). // 'Ϊ':'Ι'
      // replace( /\u03AB/g, "\u03A5" ). // 'Ϋ':'Υ'
      .replace(/\u03AC/g, "\u03B1") // 'ά':'α'
      .replace(/\u03AD/g, "\u03B5") // 'έ':'ε'
      .replace(/\u03AE/g, "\u03B7") // 'ή':'η'
      .replace(/\u03AF/g, "\u03B9") // 'ί':'ι'
      .replace(/\u03B0/g, "\u03C5") // 'ΰ':'υ'
      .replace(/\u03CA/g, "\u03B9") // 'ϊ':'ι'
      .replace(/\u03CB/g, "\u03C5") // 'ϋ':'υ'
      .replace(/\u03CC/g, "\u03BF") // 'ό':'ο'
      .replace(/\u03CD/g, "\u03C5") // 'ύ':'υ'
      .replace(/\u03CE/g, "\u03C9")

    console.log(text, typeof text)
    return text
  }
}

const toggleOverlayVisibility = (state) => {
  const menuOverlay = document.querySelector(".menu-overlay")
  if (state === "hide") {
    menuOverlay.classList.remove("active")
  } else if (state === "show") {
    menuOverlay.classList.add("active")
  }
}

/*! Edit URL
 *  Search for a give segment and remove it if found
 *  (c) 2020 Michelle Kondou, MIT License
 *  @params { string } // a url segment to search for in the pathname
 *  example use: editURL('quick-search')
 */
const editURL = (string) => {
  // Function to check whether some string is present in the url pathname
  // and then remove it
  const url = new URL(window.location.href)
  const { pathname } = url
  if (pathname) {
    const segments = pathname.split("/")
    if (segments.includes(string)) {
      const fixURL = () => {
        const finalURL = window.location.href
        const editedURL = finalURL.replace(`${string}/`, "1/")
        appPushState(editedURL)
        // TODO: on history back remove the segment also
      }
      fixURL()
    }
  }
}

const appPushState = (url, state) => {
  function supports_history_api() {
    return !!(window.history && history.pushState)
  }
  const pageInfo = {
    title: state,
    url: window.location.href,
  }
  window.history.pushState(pageInfo, null, url)
  window.history.scrollRestoration = "manual"
}

/*! Notifications
 *  Short description of what it does
 *  (c) 2020 Michelle Kondou, MIT License
 *  @params {  } //
 *  @params {  } //
 *  example use: function(argument)
 */
const notificationTimeout = "" // global pop up messages timeout function
const notificationElement = ""

const notificationsManager = (notificationContent) => {
  const notifications = document.querySelectorAll(".js-notifications-outer")

  if (notifications.length) {
    notifications.forEach((notification) => {
      // console.log(notification)
    })
  } else {
    // console.log('Notification content: ', notificationContent)
    // document.body.appendChild(notificationContent)
  }
}

const clearNotifications = (element, duration) => {
  let defaultDuration
  duration ? (defaultDuration = duration) : (defaultDuration = 3000)
  return setTimeout(() => {
    // console.log('Notification should fade out')
  }, defaultDuration)
}

const rotateElement = (element, direction) => {
  if (element && element.className)
    element.classList.remove(element.className.baseVal.match(/\brotate-\S+/g))

  if (direction === "top") {
    if (element) element.classList.add("rotate-top")
  } else if (direction === "left") {
    if (element) element.classList.add("rotate-left")
  } else if (direction === "bottom") {
    if (element) element.classList.add("rotate-bottom")
  } else if (direction === "right") {
    if (element) element.classList.add("rotate-right")
  }
}

/* Validate Slim Select */
const validateSelect = (node, value) => {
  if (node) {
    const parent = node.closest(".field")
    const errorMessage = parent.querySelector(".error-message")
    const label = parent.querySelector("label")
    if (!value) {
      errorMessage.innerHTML = `Please select an option for &nbsp; ${label.innerHTML}`
    } else {
      errorMessage.innerHTML = ""
    }
  } else {
    // console.log('Node not found')
  }
}

// const imagesToPreload = document.querySelectorAll('[data-preload] .lazyload')
// if (imagesToPreload && imagesToPreload.length > 0) {
//   preloadImages(imagesToPreload)
// }
// collection is an array of picture tags or img tags
const preloadImages = (collection) => {
  collection.forEach((el) => {
    let image
    const sourceElements = el.querySelectorAll("source")
    // If the element contains a source element
    // it means it's the picture tag
    if (sourceElements && sourceElements.length > 0) {
      image = el.querySelector("img")
      sourceElements.forEach((source) => {
        if (source.hasAttribute("data-srcset") && !image.classList.contains("fade-in")) {
          source.srcset = source.getAttribute("data-srcset")
        }
      })
    } else {
      // Else we assume it's a single img tag
      image = el
      if (image.hasAttribute("data-src") && !image.classList.contains("fade-in")) {
        image.src = image.getAttribute("data-src")
      }
    }
    image.classList.add("fade-in")
  })
}

// TODO: SOS Create function for media queries (viewport breakpoints)
// and function to reload different functions on window resize

const breakpoints = {
  mobileMax: 414,
  phabletMin: 415,
  phabletMax: 851,
  tabletMin: 852,
  tabletMax: 1279,
  desktopMin: 1280,
  mobileLayout: false,
  desktopLayout: false,
}

/*
 * trigger.addEventListener('mouseenter', debounce(test.bind(this), 500))
 */
function debounce(func, wait = 100) {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}

const vw = window.innerWidth
const vh = window.innerHeight * 0.01
const resizeConditions = (callback) => {
  // Do not fire the resize event on mobile unless a change in the viewport width
  // is detected. Chrome fires the resize event on scroll because it hides
  // the browser navigation, tab navigation etc and the height changes
  // Use debounce to fire the functions only on resize end
  if (window.isMobile) {
    if (window.innerWidth !== vw) callback()
  } else if (window.innerWidth !== vw || window.innerHeight !== vh) callback()
}

// Resize start: only run light functions like hiding content or starting a loader
// because this will fire many times while resizing
const resizeStartCallback = (callback) =>
  window.addEventListener("resize", resizeConditions.bind(this, callback))
// Resize end: this will only fire at the end of a timeout, when resizing is
// complete. This can hold heavy duty stuff like resizing or generating
// dom elements
const resizeEndCallback = (callback) =>
  window.addEventListener("resize", debounce(resizeConditions.bind(this, callback), 500))

const detectLayoutChange = (e) => {
  const vwt = window.innerWidth
  if (breakpoints.desktopLayout && vwt < breakpoints.tabletMin) {
    // console.log('Switched to mobile')
    window.location.reload()
  }

  if (breakpoints.mobileLayout && vwt > breakpoints.phabletMax) {
    // console.log('Switched to Desktop')
    window.location.reload()
  }
}

// Function to calculate the coorect clamp sizes
function clampBuilder(minWidthPx, maxWidthPx, minFontSize, maxFontSize) {
  const root = document.querySelector("html")
  const pixelsPerRem = Number(getComputedStyle(root).fontSize.slice(0, -2))

  const minWidth = minWidthPx / pixelsPerRem
  const maxWidth = maxWidthPx / pixelsPerRem

  const slope = (maxFontSize - minFontSize) / (maxWidth - minWidth)
  const yAxisIntersection = -minWidth * slope + minFontSize

  return `clamp( ${minFontSize}rem, ${yAxisIntersection}rem + ${slope * 100}vw, ${maxFontSize}rem )`
}

// console.log(clampBuilder(424, 1440, 3.375, 4.625))

const showResizeOverlay = () => {
  const vwt = window.innerWidth

  const overlay = document.querySelector(".menu-overlay")
  if (overlay) {
    if (breakpoints.desktopLayout && vwt < breakpoints.tabletMin) {
      overlay.classList.add("menu-overlay--white")
      overlay.classList.add("active")
      overlay.classList.add("loading")
    }

    if (breakpoints.mobileLayout && vwt > breakpoints.phabletMax) {
      overlay.classList.add("menu-overlay--white")
      overlay.classList.add("active")
      overlay.classList.add("loading")
    }
  }
}

const passwordVisibilityToggle = () => {
  const toggleVisibilityBtns = document.querySelectorAll(".toggle-password")

  if (toggleVisibilityBtns.length > 0 && toggleVisibilityBtns) {
    toggleVisibilityBtns.forEach((item) => {
      const passwordInput = item.parentElement.querySelector('input[type="password"]')
      const onIcon = item.querySelector(".visibility-on")
      const offIcon = item.querySelector(".visibility-off")
      // Always hide password on page load
      item.classList.add("off")

      item.addEventListener("click", (e) => {
        if (e && e.target) {
          const target = e.target
          if (target && target.classList.contains("off")) {
            target.classList.remove("off")
            target.classList.add("on")
            passwordInput.type = "text"
            onIcon.classList.add("active")
            offIcon.classList.remove("active")
          } else {
            target.classList.remove("on")
            target.classList.add("off")
            passwordInput.type = "password"
            onIcon.classList.remove("active")
            offIcon.classList.add("active")
          }
        }
      })
    })
  }
}

const reportFormData = (data) => {
  console.log("!!! START FORM DATA")
  for (var pair of data.entries()) {
    console.log(pair[0] + ": " + pair[1])
  }
  console.log("!!! END FORM DATA")
}

const reportForm = (data) => {
  // console.log('!!! START FORM DATA')
  console.log(data)
  // console.log('!!! END FORM DATA')
}

const toggleModal = (isOpen) => {
  const html = document.documentElement
  if (isOpen) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    html.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`)
    html.classList.add("modal-open")
  } else {
    html.style.removeProperty("--scrollbar-width")
    html.classList.remove("modal-open")
  }
}

export {
  serialize,
  postFormData,
  calculateAspectRatio,
  accordion,
  autoOpenFirstAccordion,
  doneTyping,
  removeAccents,
  toggleOverlayVisibility,
  getCookie,
  notificationsManager,
  rotateElement,
  editURL,
  resizeStartCallback,
  resizeEndCallback,
  breakpoints,
  detectLayoutChange,
  preloadImages,
  validateSelect,
  debounce,
  showResizeOverlay,
  accordionMobile,
  decodeEntities,
  removeAccentsTest,
  passwordVisibilityToggle,
  reportFormData,
  reportForm,
  accordionWithCaret,
  toggleModal,
}
